import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);
export const THEMES = ["light", "dark", "accent"];

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => localStorage.getItem("sd_theme") || "light");

  useEffect(() => {
    const el = document.documentElement;
    el.classList.remove("light", "dark", "accent");
    if (theme !== "light") el.classList.add(theme);
    localStorage.setItem("sd_theme", theme);
  }, [theme]);

  const cycle = () => setTheme((t) => THEMES[(THEMES.indexOf(t) + 1) % THEMES.length]);

  return <ThemeContext.Provider value={{ theme, setTheme, cycle }}>{children}</ThemeContext.Provider>;
}

export const useTheme = () => useContext(ThemeContext);
